import { useSearchParams } from 'react-router';
import { AccessScreen } from '@/features/access/components/access-screen';
import { Page } from '@/shared/components/page/page';
import { PageHeader } from '@/shared/components/page/page-header';
import { useTranslation } from '@/shared/i18n/use-translation';

export function AccessPage() {
  const [params] = useSearchParams();
  const { t } = useTranslation();
  return (
    <Page className="max-w-3xl">
      <PageHeader
        title={t('Sessions and access')}
        description={t('Approve the agents that ask you and revoke what you no longer use.')}
      />
      <AccessScreen code={params.get('code')} />
    </Page>
  );
}
